if(!customElements.get('common-tabs')){
    class CommonTabs extends HTMLElement {
        constructor(){
            super()
        }
        connectedCallback(){
            setTimeout(() => {
                this.initEvents()
            }, 0);
        }
        initEvents() {
            this.tabs = this.querySelectorAll('.common-tab-item')
            this.target = this.dataset.target //for slideshow toggle
            this.toggleType = this.dataset.toggle
            this.flkty = null
            this.slider = null
            if(this.target) {
                this.slider = document.getElementById(this.target)
                this.flkty = Flickity.data(this.slider)
            }
            this.tabContainer = this; // 滚动的容器
            this.containerWidth = this.tabContainer.clientWidth; // 容器的可视宽度
            this.tabWidth = this.tabs[0].clientWidth; // 当前 tab 的宽度
            this.tabs.forEach((tab, index) => {
                tab.addEventListener('click', (e) => {
                    this.tabs.forEach(item => item.classList.remove('active'));
                    tab.classList.add('active')
                    if(this.toggleType === 'index') {
                        this.toggleIndex(index)
                    }
                    if(this.toggleType === 'slides') {
                        this.toggleSlides(index + 1)
                    }
                    if(window.innerWidth < 768) {
                        // tab.scrollIntoView({ behavior: "smooth", inline: "center" });
                        this.tabMoveToView(tab)
                    }
                })
            })
        }
        toggleIndex(index) {
            if(this.flkty) {
                this.flkty.select(index)
            }
        }
        toggleSlides(index) {
            let tabs = this.slider.querySelectorAll(`.null-column:not([data-tab*="${index}"])`),
            active_tabs = this.slider.querySelectorAll(`[data-tab*="${index}"]`);
            [].forEach.call(tabs, (el) => {
                el.classList.remove('carousel__slide');
                this.slider.append(el);
            });
            [].forEach.call(active_tabs, (el) => {
                el.classList.add('carousel__slide');
            });
            // var maxHeight = 0;
            // active_tabs.forEach(item => {
            //   var height = item.offsetHeight;
            //   if (height > maxHeight) {
            //     maxHeight = height;
            //   }
            // })
            // // 将所有幻灯片的高度设置为最大高度
            // active_tabs.forEach(function(slide){
            //   slide.style.height = maxHeight + 'px';
            // });
            this.flkty.insert(active_tabs);
            this.flkty.reloadCells();
            this.flkty.select(0, 0, 1);
            if(this.slider.classList.contains('video-slideshow')) {
                let nextBtn = this.slider.parentNode.querySelector('.slide-next')
                let prevBtn = this.slider.parentNode.querySelector('.slide-prev')
                
                if(this.flkty.cells.length < 4) {
                  nextBtn.style.display = 'none'
                  prevBtn.style.display = 'none'
                }else {
                    nextBtn.style.display = 'block'
                    prevBtn.style.display = 'block'
                }
              }
        }
        tabMoveToView(tab) {
            // tab.scrollIntoView({ behavior: "smooth", inline: "center" });
            const tabOffsetLeft = tab.offsetLeft; // 当前 tab 距离容器左侧的偏移
            // 计算滚动距离，让 tab 居中
            const scrollLeft = tabOffsetLeft - (this.containerWidth / 2) + (this.tabWidth / 2);
            // 平滑滚动
            this.tabContainer.scrollTo({
                left: scrollLeft,
                behavior: 'smooth'
            });
        }
    }
    customElements.define('common-tabs', CommonTabs)
}